let language = {
    "MY-ACCOUNT-ALERT-FAIL": "Failed",
    "MY_ACCOUNT_RESET_PASSWORD_FAILED_TITLE": "Password reset unsuccessful",
    "MY_ACCOUNT_RESET_PASSWORD_FAILED_CONTENT1": "Your new password cannot be the same as your email address. Please enter another password and try again.",
    "MY_ACCOUNT_RESET_PASSWORD_FAILED_CONTENT2": "Your new password is the same as your old password. Please enter another password and try again.",
    "MY_ACCOUNT_RESET_PASSWORD_FAILED_CONTENT3": "Your old password is incorrect. Please double-check your old password and try again.",
    "MY_ACCOUNT_RESET_PASSWORD_FAILED_CONTENT4": "Your new password cannot be the same as your account full name. Please enter another password and try again.",
    "MY_ACCOUNT_RESET_NEW_PASS_Tip1": "Please input 8 to 20 characters(including uppercase, lowercase, numbers and symbols)",
    "MY_ACCOUNT_RESET_NEW_PASS_Tip2":"Your new password and old password cannot be the same",
    "MY_ACCOUNT_RESET_NEW_PASS_Tip3":"Your password cannot be the same as your email address",
    "MY_ACCOUNT_RESET_NEW_PASS_Tip4":"Your password cannot be the same as your account full name",
    "MY_ACCOUNT_RESET_OLD_PASS_Tip1":"Your old password is incorrect"

};

export { language }